module.exports = __webpack_public_path__ + "html/mari-smith-tutorials_05ff7f4953807183796abef5a72cc656.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/mari-smith-tutorials.html
// module id = wL/W
// module chunks = 36